import { render } from "./GeneralAnalyticsList.vue?vue&type=template&id=0dfb37b8&scoped=true"
import script from "./GeneralAnalyticsList.vue?vue&type=script&lang=js"
export * from "./GeneralAnalyticsList.vue?vue&type=script&lang=js"

import "./GeneralAnalyticsList.vue?vue&type=style&index=0&id=0dfb37b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfb37b8"]])

export default __exports__